import { toNet, toNumber } from "../../shared/money";
import { itemTax } from "./data";
import type { BundleLine, PriceListData } from "./meta";

/*
 * What a bundle adds up to: each item at its own price and cost (ServiceM8 adds them to a job one
 * by one), before tax and with each item's tax, so items in different bases add up properly.
 */

export interface BundleTotals {
    priceNet: number;
    priceWithTax: number;
    costNet: number;
    /** Items in it that no longer exist (left out of the totals). */
    missing: number;
}

export function bundleTotals(data: PriceListData, lines: readonly BundleLine[]): BundleTotals {
    const byUuid = new Map(data.materials.map((m) => [m.uuid, m]));
    const totals: BundleTotals = { priceNet: 0, priceWithTax: 0, costNet: 0, missing: 0 };
    for (const l of lines) {
        const m = byUuid.get(l.uuid);
        if (!m) {
            totals.missing++;
            continue;
        }
        const { tax } = itemTax(data, m);
        const priceNet = toNet(toNumber(m.price), m.price_includes_taxes, tax) * l.quantity;
        totals.priceNet += priceNet;
        totals.priceWithTax += priceNet * (1 + tax);
        totals.costNet += toNet(toNumber(m.cost), m.price_includes_taxes, tax) * l.quantity;
    }
    return totals;
}
